import React from "react";

export const Quote = ({block}) => {
  return <div className="blog-quote">
    <div className="blog-quote-content" dangerouslySetInnerHTML={{__html: block.data.text}}/>
    <div className="blog-quote-author" dangerouslySetInnerHTML={{__html: block.data.caption}}/>
  </div>
}
